import {
  AppBar, Box, Button, Checkbox, Fab, FormControl, IconButton, InputLabel, List, ListItem,
  ListItemButton, ListItemIcon, ListItemText, ListSubheader,
  MenuItem,
  Select,
  Toolbar, Typography
} from "@mui/material";
import { collection, query, onSnapshot, orderBy, where } from "firebase/firestore";
import { useEffect, useMemo, useState } from 'react';
import { auth, db } from '../../firebase';

import { useAuthState } from "react-firebase-hooks/auth";
import { timeConvert } from "../../helpers";
import { groupTimeMinutes } from "shared";
import AdminNavbar from "../../components/AdminNavbar";

export default function Que() {
  const [user, authLoading, error] = useAuthState(auth);
  const [que, setQue] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState('sydney');
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const q = query(collection(db, `ques/${location}/guests`), orderBy('created'), where('status', 'in', ['waiting', 'called', 'inside']))
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      setQue(querySnapshot.docs.map(doc => ({
        id: doc.id,
        data: doc.data()
      })))
    });

    return () => {
      unsubscribe();
    }

  }, [location])

  useMemo(() => {
    onSnapshot(query(collection(db, 'locations')), (querySnapshot) => {
      const list = [];
      querySnapshot.forEach((doc) => {
        list.push({ ...doc.data(), id: doc.id });
      });

      setLocations(list);
    });
  }, []);

  const calcTimeWaiting = (started) => {
    return timeConvert((new Date().getTime() - started) / 1000 / 60)
  }

  const handleSelect = (id) => {
    const index = selected.findIndex(i => i === id)
    if (index === -1) {
      setSelected(selected.concat(id))
    } else {
      setSelected(selected.filter(i => i !== id))
    }
  }

  const handleUpdate = (e) => {
    e.preventDefault();
    if (!selected.length)
      return;
    setLoading(true);
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids: selected, location })
    }
    fetch(process.env.REACT_APP_FN_URL + "/moveNext", requestOptions)
      .then(res => res.json())
      .then((result) => {
        console.log(result);
        setSelected([])
        setLoading(false);
      },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          console.error(error);
          setSelected([]);
          setLoading(false);
        }
      )
  }

  //   <Box sx={{ flexGrow: 1 }}>
  //   {user && <LoadingButton style={{marginLeft: 5}} variant="outlined" disabled={selected.length === 0} loading={loading} color="inherit" onClick={handleUpdate}>Next</LoadingButton>}
  // </Box>

  const ButtonAppBar = (props) => {
    return (
      user && <Fab
        disabled={selected.length === 0 || loading}
        variant="outlined"
        onClick={handleUpdate}
        sx={{
          position: 'absolute',
          bottom: 16,
          right: 16
        }}>
        Next
      </Fab>
    );
  }

  const listQue = (status) => {
    const q = que.filter(q => q.data.status === status);

    return (
      <List sx={{ width: '100%' }}
        subheader={<ListSubheader>{status.toUpperCase()} ({q.length})  {timeConvert(q.length * groupTimeMinutes)}</ListSubheader>}
      >
        {q.map((q) => (
          <ListItem
            key={q.id}
            disablePadding>
            <ListItemButton role={undefined} onClick={() => handleSelect(q.id.toString())} dense>
              {user && <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={selected.includes(q.id)}
                  tabIndex={-1}
                  disableRipple
                />
              </ListItemIcon>}
              <ListItemText id={q.id} primary={`${q.data.name} - ${q.data.groupSize} (${calcTimeWaiting(q.data[status === "waiting" ? "created" : status])})`} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    )
  }

  return (
    <>
      <AdminNavbar />
      <Box sx={{ flexGrow: 1, marginTop: 2, marginLeft: 1 }}>
        <FormControl>
          <InputLabel>Location</InputLabel>
          <Select
            value={location}
            label="Location"
            onChange={(event) => {
              setLocation(event.target.value)
              setSelected([]);
            }}
            style={{ minWidth: "100%" }}
          >
            {
              locations.map((location) => <MenuItem key={location.id} value={location.id}>{location.name}</MenuItem>)
            }
          </Select>
        </FormControl> 
      </Box>
      {listQue("inside")}
      {listQue("called")}
      {listQue("waiting")}
      <ButtonAppBar />
    </>
  );
}
